// extracted by mini-css-extract-plugin
export default {"icon":"CloseDossierButton_icon__3yjyr","button":"CloseDossierButton_button__fa42f"};